import { axios_ } from '../../tools/axios_';
import { getToken } from '../../tools/utils';

//查询商户协议签署状态get
export const queryMerchantsAgreementStatus = (orgId, userId) => {
    return axios_({
        url: `/api/organization/org/agreement/${orgId}`,
        method: 'get',
        headers: { 'Authorization': getToken() },
        params: { userId }
    })
}

//拒绝签署协议post
export const refusedSignedAgreement = (orgId) => {
    return axios_({
        url: `/api/organization/org/agreement/${orgId}/reject`,
        method: 'POST',
        data: {},
        headers: { 'Authorization': getToken() }
    })
}

//查看签名文件
export const viewSignatureFile = (orgId, userId) => {
    return axios_({
        url: `/api/organization/org/agreement/h5/${orgId}/sign-file`,
        method: 'get',
        headers: { 'Authorization': getToken() },
        params: {
            userId
        }
    })
}

//获取协议模板内容
export const getAgreementTemplate = (orgId, userId) => {
    return axios_({
        url: `/api/organization/org/agreement/h5/${orgId}/content`,
        method: 'get',
        headers: { 'Authorization': getToken() },
        params: {
            userId
        }
    })
}

export const getProcess = (userId, orgId) => {
    const domainName = window.location.origin;
    if (domainName.indexOf('localhost') > -1) {
        //本地
        return `http://192.168.124.13:3001/activities/identity-real/sign?userId=${userId}&orgId=${orgId}`;
    }
    else if (domainName.indexOf('test') > -1) {
        //测试
        return `https://shop.test.zhongbaounion.com/activities/identity-real/sign?userId=${userId}&orgId=${orgId}`;
    }
    else if (domainName.indexOf('staging') > -1) {
        //uat
        return ` https://shop.staging.zhongbaounion.com/activities/identity-real/sign?userId=${userId}&orgId=${orgId}`;
    }
    return `https://shop.zhongbaounion.com/activities/identity-real/sign?userId=${userId}&orgId=${orgId}`;
}

// 判断是否为活跃
export const getIsInactive = (orgId) => {
    return axios_({
        url: `/api/organization/orgInfo/isOrgContainOnlineProduct`,
        method: 'get',
        headers: { 'Authorization': getToken() },
        params: {
            orgId
        }
    })
}